/*
 * @Author: LiZhiWei
 * @Date: 2026-01-13 15:01:49
 * @LastEditors: LiZhiWei
 * @LastEditTime: 2026-01-23 14:58:37
 * @Description:
 */
import type { Config } from '~/types/config'
export const appName = '海南绘家科技有限公司'
export const appDescription = '海南绘家科技有限公司'
export const apiBase = import.meta.env.VITE_API_URL

const config: Config = {
  websiteTitle: appName,
  defaultSettings: {
    /**
     * @type String
     * @description Application's default title
     */
    title: '绘家',

    /**
     * @type {boolean} true | false
     * @description Whether need tagsView
     */
    tagsView: true,

    /**
     * @type {boolean} true | false
     * @description Whether fix the header
     */
    fixedHeader: true,

    /**
     * @type {boolean} true | false
     * @description Whether show the logo in sidebar
     */
    sidebarLogo: true,

    /**
     * @type {string | array} 'production' | ['production', 'development']
     * @description Need show err logs component.
     * The default is only used in the production env
     * If you want to also use it in dev, you can pass ['production', 'development']
     */
    errorLog: ['production', 'development'],
  },
}

export default config
